<template>
  <div class="home-page-wrapper">
    <transition name="message-fade">
      <div v-if="showMessage" :class="['custom-message', messageType]">
        <p>{{ messageText }}</p>
      </div>
    </transition>
    <div class="iphone-container">
      <div class="background-image"></div>
      <div class="gradient-overlay"></div>
      <div class="main-content">
        <div class="greeting">Hello, lera!</div>
        <div class="form-container">
          <div class="input-field car-number">
            <input
                type="text"
                placeholder="输入您的车牌号"
                v-model="carNumber"
                @click="openKeyboard"
                readonly
            />
          </div>
          <div class="input-field bill-number">
            <input
                type="text"
                placeholder="输入提单号"
                v-model="billNumber"
                maxlength="30"
            />
          </div>
          <div class="input-field container-number">
            <input
                type="text"
                placeholder="输入柜号"
                v-model="containerNumber"
                maxlength="12"
            />
          </div>
          <div class="input-field driver-name">
            <input type="text" placeholder="输入姓名" v-model="driverName"/>
          </div>
          <div class="input-field driver-phone">
            <input
                type="tel"
                placeholder="输入电话"
                v-model="driverPhone"
                maxlength="11"
            />
          </div>
        </div>

        <p v-if="validationError" class="error-message">{{ validationError }}</p>
        <button
            class="confirm-button"
            @click="submitForm"
            :disabled="isSubmitting"
        >
          {{ isSubmitting ? '提交中...' : '确认' }}
        </button>
      </div>
    </div>

    <div
        v-if="showCarKeyboard"
        class="keyboard-overlay"
        @click="closeKeyboard"
    >
      <div class="keyboard-content" @click.stop>
        <div class="keyboard-header">
          <span class="plate-preview">{{ carNumber || '请输入车牌号' }}</span>
          <button @click="closeKeyboard">完成</button>
        </div>
        <div v-if="step === 1" class="keyboard-keys">
          <div
              v-for="key in provinceKeys"
              :key="key"
              class="keyboard-key"
              @click="inputProvince(key)"
          >
            {{ key }}
          </div>
        </div>
        <div v-if="step === 2" class="keyboard-keys">
          <div
              v-for="key in letterKeys"
              :key="key"
              class="keyboard-key"
              @click="inputLetter(key)"
          >
            {{ key }}
          </div>
          <div class="keyboard-key delete" @click="deleteKey">删除</div>
        </div>
        <div v-if="step === 3" class="keyboard-keys">
          <div
              v-for="key in mixedKeys"
              :key="key"
              class="keyboard-key"
              @click="inputMixed(key)"
          >
            {{ key }}
          </div>
          <div class="keyboard-key delete" @click="deleteKey">删除</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {submitLoadingInfo, queryLatestShipment} from '@/api/wx';

export default {
  name: 'HomePage',
  data() {
    return {
      carNumber: '',
      billNumber: '',
      containerNumber: '',
      driverName: '',
      driverPhone: '',
      bindInfoId: '',
      openid: '',
      showCarKeyboard: false,
      step: 1,
      isSubmitting: false,
      showMessage: false,
      messageText: '',
      messageType: 'warning',
      messageTimer: null,
      provinceKeys: ['京', '津', '冀', '晋', '蒙', '辽', '吉', '黑', '沪', '苏', '浙', '皖', '闽', '赣', '鲁', '豫', '鄂', '湘', '粤', '桂', '琼', '渝', '川', '贵', '云', '藏', '陕', '甘', '青', '宁', '新'],
      letterKeys: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      mixedKeys: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
    };
  },
  created() {
    const openid = localStorage.getItem('user-openid');
    if (openid) {
      this.openid = openid;
    } else {
      this.$router.push('/');
    }
    const {driverName, driverPhone,bindInfoId} = this.$route.query;
    if (driverName) {
      this.driverName = driverName;
    }
    if (driverPhone) {
      this.driverPhone = driverPhone;
    }
    if (bindInfoId) {
      this.bindInfoId = bindInfoId;
    }
  },
  methods: {
    triggerMessage(text, type = 'warning', duration = 3000) {
      if (this.messageTimer) {
        clearTimeout(this.messageTimer);
      }
      this.messageText = text;
      this.messageType = type;
      this.showMessage = true;

      this.messageTimer = setTimeout(() => {
        this.showMessage = false;
      }, duration);
    },
    openKeyboard() {
      this.showCarKeyboard = true;
      this.step = 1;
    },
    closeKeyboard() {
      this.showCarKeyboard = false;
    },
    inputProvince(key) {
      this.carNumber = key;
      this.step = 2;
    },
    inputLetter(key) {
      if (this.carNumber.length < 2) {
        this.carNumber += key;
        this.step = 3;
      }
    },
    inputMixed(key) {
      if (this.carNumber.length < 8) {
        this.carNumber += key;
      }
    },
    deleteKey() {
      this.carNumber = this.carNumber.slice(0, -1);
      if (this.carNumber.length === 0) {
        this.step = 1;
      } else if (this.carNumber.length === 1) {
        this.step = 2;
      } else {
        this.step = 3;
      }
    },
    validateForm() {
      if (!this.carNumber.trim()) {
        this.triggerMessage('请输入车牌号');
        return false;
      }
      if (this.carNumber.length < 7 || this.carNumber.length > 8) {
        this.triggerMessage('车牌号长度应为7-8位');
        return false;
      }
      if (!this.billNumber.trim()) {
        this.triggerMessage('请输入提单号');
        return false;
      }
      if (!this.containerNumber.trim()) {
        this.triggerMessage('请输入柜号');
        return false;
      }
      if (this.driverPhone && !/^\d{11}$/.test(this.driverPhone)) {
        this.triggerMessage('司机电话必须为11位数字');
        return false;
      }
      return true;
    },
    async submitForm() {
      if (this.isSubmitting || !this.validateForm()) {
        return;
      }
      this.isSubmitting = true;

      const formData = {
        openId: this.openid,
        licenseNo: this.carNumber,
        containerNo: this.containerNumber,
        billNo: this.billNumber,
        driverName: this.driverName,
        driverPhone: this.driverPhone,
        bindInfoId: this.bindInfoId,
      };

      try {
        await submitLoadingInfo(formData);
        const shipmentStatus = await queryLatestShipment(this.openid);
        sessionStorage.setItem(
            'latestShipment',
            JSON.stringify(shipmentStatus)
        );
        this.triggerMessage('提交成功!', 'success', 1500);
        setTimeout(() => {
          this.$router.push({name: 'StatusPage'});
        }, 1500);
      } catch (error) {
        this.triggerMessage(error.message || '提交失败，请稍后重试', 'error');
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Barlow', sans-serif;
}

.iphone-container {
  width: 100%;
  max-width: 400px;
  height: 100vh;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
  background-color: #d6e4ee;
}

.main-content {
  position: relative;
  z-index: 2;
  width: 90%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding-top: 25vh;
  padding-bottom: 20px;
}

.greeting {
  flex-shrink: 0;
  margin-bottom: 24px;
  font-size: 32px;
  font-weight: 500;
  color: #ffffff;
  white-space: nowrap;
  width: 100%;
  text-align: left;
}

.form-container {
  flex-shrink: 1;
  overflow-y: auto;
  width: 100%;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 20px 12px 30px 12px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.error-message {
  color: #d93025;
  font-size: 14px;
  text-align: center;
  margin-top: -12px;
  margin-bottom: 16px;
  height: 16px;
}

.confirm-button {
  flex-shrink: 0;
  margin-top: 24px;
  width: 100%;
  padding: 16px 40px;
  background-color: #00416b;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  text-align: center;
  transition: background-color 0.3s;
}

.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 40%;
  background-image: url('@/assets/lera.png');
  background-size: cover;
  background-position: center;
  z-index: 0;
}

.gradient-overlay {
  position: absolute;
  top: 40vh;
  left: 0;
  width: 100%;
  height: 70vh;
  background: linear-gradient(180deg, rgba(0, 54, 90, 1) 20%, rgba(199, 219, 233, 1) 45%, rgba(214, 228, 238, 1) 100%);
  z-index: 1;
}

.input-field {
  width: 100%;
}

.input-field input {
  width: 100%;
  padding: 12px;
  border: none;
  border-bottom: 1px solid rgba(224, 224, 224, 1);
  font-size: 16px;
  outline: none;
}

.input-field.car-number input {
  height: 54px;
  border-radius: 8px;
  padding: 16px 12px;
  background-color: rgba(241, 241, 241, 1);
}

.input-field input::placeholder {
  color: rgba(144, 144, 144, 1);
}

.confirm-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.keyboard-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 20;
}

.keyboard-content {
  width: 100%;
  max-width: 400px;
  background-color: #f5f5f5;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  padding: 16px;
  margin: 0 auto;
}

.keyboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.plate-preview {
  font-family: monospace;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 2px;
  color: #00416b;
  min-width: 120px;
  text-align: left;
}

.keyboard-header button {
  background-color: #00416b;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  cursor: pointer;
}

.keyboard-keys {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 8px;
}

.keyboard-key {
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 12px;
  text-align: center;
  cursor: pointer;
  font-size: 14px;
  user-select: none;
}

.keyboard-key:active {
  background-color: #e0e0e0;
}

.keyboard-key.delete {
  grid-column: span 2;
  background-color: #ff4d4f;
  color: white;
}
.custom-message {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 10px 20px;
  border-radius: 8px;
  /* color: #fff;  <-- 文字颜色将由具体类型决定，可以移除 */
  font-size: 14px;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.custom-message.warning {
  background-color: #fdf6ec; /* Element Plus 警告样式的背景色 */
  color: #e6a23c;            /* Element Plus 警告样式的文字颜色 */
}
/* 错误消息的样式 */
.custom-message.error {
  background-color: #f56c6c;
  color: #fff;
}

/* 保留：成功消息的样式 */
.custom-message.success {
  background-color: #67c23a;
  color: #fff;
}

/* 为 <transition> 组件定义的动画效果 */
.message-fade-enter-active,
.message-fade-leave-active {
  transition: opacity 0.3s, transform 0.3s ease;
}
.message-fade-enter, .message-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, -20px);
}
</style>